import { render, staticRenderFns } from "./Rules.vue?vue&type=template&id=0683f0c6"
import script from "./Rules.vue?vue&type=script&lang=ts"
export * from "./Rules.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports